import { Badge, Button, Spinner } from "reactstrap";
import { getUsageStatusLabel } from "../helpers/measureList";
import {
    USAGE_DECISION_NO,
    USAGE_DECISION_YES,
    measureRequiresUserConfirmation,
} from "../helpers/usage";

const USAGE_BADGE_COLOR = {
    yes: "success",
    no: "secondary",
    to_review: "warning",
};

const UsageDecision = ({ measure, isSaving, onChange, t }) => {
    const usageStatus = measure?.usage_status;

    if (!measureRequiresUserConfirmation(measure)) {
        return (
            <Badge color={USAGE_BADGE_COLOR[usageStatus] || "light"} className={`bg-${USAGE_BADGE_COLOR[usageStatus] || "light"}`} pill>
                {t(getUsageStatusLabel(usageStatus))}
            </Badge>
        );
    }

    return (
        <div className="d-flex align-items-center gap-1">
            <Button
                size="sm"
                color="success"
                outline={usageStatus !== USAGE_DECISION_YES}
                disabled={isSaving || usageStatus === USAGE_DECISION_YES}
                onClick={(event) => {
                    event.stopPropagation();
                    onChange(measure.id, USAGE_DECISION_YES);
                }}
            >
                {isSaving && usageStatus !== USAGE_DECISION_YES && (
                    <Spinner size="sm" className="me-1" />
                )}
                {t("Yes")}
            </Button>
            <Button
                size="sm"
                color="secondary"
                outline={usageStatus !== USAGE_DECISION_NO}
                disabled={isSaving || usageStatus === USAGE_DECISION_NO}
                onClick={(event) => {
                    event.stopPropagation();
                    onChange(measure.id, USAGE_DECISION_NO);
                }}
            >
                {isSaving && usageStatus !== USAGE_DECISION_NO && (
                    <Spinner size="sm" className="me-1" />
                )}
                {t("No")}
            </Button>
        </div>
    );
};

export default UsageDecision;
